export default __webpack_public_path__ + "static/icon_production-8b0ca12ef3a17945854d7e5e05da6fd3.png";